module.exports = __webpack_public_path__ + "static/media/statusSuccess.46ed423e.svg";